<template>
  <div class="container" v-if="viewContent && viewContent.categories && viewContent.categories.length > 0">
    <div v-for="category in viewContent.categories" :key="category.id">
      <h3>{{category.title}}</h3>
      <h5 v-if="category && category.apps && category.apps.length > 0">{{category.short_desc}}</h5>
      <h5 v-else>There are no active apps in the category.</h5>
      <tile-container :apps="category.apps" :category="category" :view="viewContent"></tile-container>
    </div>
  </div>
  <div v-else>
    <div class="container no-content-container">
      <div class="row">
        <div class="col-12">
          <h4>There are no active categories for this view.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import TileContainer from '@/components/TileContainer'

export default {
  name: 'ViewContainer',
  components: {
    TileContainer
  },
  data: function () {
    return {
      viewContent: null
    }
  },
  watch: {
    $route (to, from) {
      this.updateViewData(to.params.pathMatch)
    }
  },
  computed: {
    ...mapGetters(['getViewType', 'getApplications'])
  },
  mounted () {
    this.updateViewData()
  },
  methods: {
    ...mapActions(['retrieveViewFromRoute', 'addAlert']),
    updateViewData () {
      this.retrieveViewFromRoute(this.$router.currentRoute.params.pathMatch)
        .then((resp) => {
          if (resp) {
            this.viewContent = resp
          } else {
            this.$router.push({ path: '/' })
          }
        }).catch(e => {
          console.error(e)
          this.$router.push({ path: '/' })
        })
    }
  }
}
</script>
<style scoped>
.no-content-container {
  margin-top: 20px;
}
</style>